<template>
  <div>
  <topup-header-image/>
  <swiper
    ref="swiper"
    id="selectTopupTypeFazole"
    :label1="this.$i18n.t('TOPUP.AUTOMATIC.HEADER')"
    :label2="this.$i18n.t('TOPUP.ONCE.HEADER')"
    :choose-header="this.$i18n.t('TOPUP.CHOOSE')"
  />
  <narrow-container>
  <div v-if="selectedTopup == 0">
      <h1 class="headline-small text--center">
        {{ this.$i18n.t('TOPUP.AUTOMATIC.HEADER') + "." }}
      </h1>
      <auto-top-up />
  </div>
  <div v-if="selectedTopup == 1">
    <h1 class="headline-small text--center">
      {{ this.$i18n.t('TOPUP.ONCE.HEADER') + "."}}
    </h1>
    <br>
    <top-up-once/>
  </div>
  </narrow-container>
  </div>
</template>

<script>
import AutoTopUp from "@/views/autotopup/AutoTopUp";
import TopUpOnce from "@/views/topupOnce/TopUpOnce";
import TopupHeaderImage from "@/components/topup-header-image/TopupHeaderImage.vue";

export default {
  name: "TopUp",
  components: {AutoTopUp, TopUpOnce, TopupHeaderImage },
  data: function() {
    return {
      isMounted: false
    }
  },
  mounted: function() {
    this.isMounted = true;
  },
  computed: {
    selectedTopup: function() {
      if (this.isMounted) {
        return this.$refs.swiper.getOption();
      } else return 0;
    }
  }
}
</script>
